export default __webpack_public_path__ + "static/media/Mountains_Widescreen_Background.ffa78eeb.jpg";